import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  CircularProgress,
  Typography,
  Button
} from '@material-ui/core';

import NewReleases from '@material-ui/icons/NewReleases';

import { getPurchaseOrders } from '../../api/resources/PurchaseOrders';

import * as defs from './PurchaseOrder.module.scss';
import * as rlDefs from '../resourceList.module.scss';

const PER_PAGE = 10;

const isPOSeenBy = (po, user) => po.seenBy.map(account => account.email).includes(user.email);

class PurchaseOrders extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      count: 0,
      size: PER_PAGE,
      start: 1,
      end: PER_PAGE,
      currentPage: 1,
      before: null,
      after: null,
      purchaseOrders: []
    }
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  componentDidMount() {
    this.load()
  }

  componentDidUpdate(prevProps) {
    if (this.props.isEscalated != prevProps.isEscalated ||this.props.isProvisional != prevProps.isProvisional) {
      this.load()
    }
  }

  load({before = null, after = null} = {}) {
    const { status, isEscalated, isProvisional} = this.props;
    let { size, end } = this.state;
    getPurchaseOrders(status, isEscalated, isProvisional, size, before, after).then(({purchaseOrders, count}) => {
      let { data, before, after } = purchaseOrders;
      if (size > count) end = count;
      if (data) purchaseOrders = data; // Hack, need to fix the way fauna-api.js recursively removes data function if there's no pagination present.
      this.setState({ purchaseOrders, count, before, after, end, loading: false })
    })
  }

  next() {
    let { size, currentPage, after, count } = this.state;
    currentPage += 1;
    let start = (currentPage - 1) * size + 1;
    let end = start + size - 1;
    if (end > count) {
      end = count;
    }
    this.setState({ currentPage, start, end, loading: true }, () => this.load({after}));
  }

  previous() {
    let { size, currentPage, before } = this.state;
    currentPage -= 1;
    let start = (currentPage - 1) * size + 1;
    if (start < 1) {
      start = 1;
      currentPage = 1;
    }
    let end = start + size - 1;
    this.setState({ currentPage, start, end, loading: true }, () => this.load({before}));
  }

  render() {

    const { purchaseOrders, loading, count, size, before, after, start, end, currentPage } = this.state;
    const { user } = this.props;

    return (<>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell style={{minWidth: '200px'}}><strong>PO Number</strong></TableCell>
              <TableCell align="left"><strong>Raised by</strong></TableCell>
              <TableCell align="left"><strong>Location</strong></TableCell>
              <TableCell align="left"><strong>Supplier</strong></TableCell>
              <TableCell align="right"><strong>Total (ex VAT)</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { !purchaseOrders && (
              <TableRow><TableCell colSpan={5} style={{height: '200px', textAlign: 'center'}}><CircularProgress /></TableCell></TableRow>
            )}
            { purchaseOrders && purchaseOrders.length === 0 && <TableRow><TableCell colSpan={5} className={rlDefs.resourceListFailedMessage}>No matching purchase orders found</TableCell></TableRow> }
            { purchaseOrders && purchaseOrders.length > 0 && purchaseOrders.map((po, idx) => (
              <TableRow key={idx}>
                <TableCell style={{minWidth: '200px'}} component="td" scope="row">
                  <Link
                    to={`/purchase-orders/${po.id}`}
                    style={{fontWeight: isPOSeenBy(po, user) ? 'normal': 'bold', verticalAlign: 'top' }}
                  >{po.purchaseOrderNumber ? po.purchaseOrderNumber: `(Pending order from ${po.supplier.name})`}</Link>
                  { po.isProvisional && <div className={defs.provisionalLozengeIndex}><NewReleases style={{fontSize: '18px', marginTop: '1px', marginRight: '3px'}} /><span >Provisional</span></div>}
                </TableCell>
                <TableCell align="left" style={{fontWeight: isPOSeenBy(po, user) ? 'normal': 'bold' }}>{po.user.name}</TableCell>
                <TableCell align="left" style={{fontWeight: isPOSeenBy(po, user) ? 'normal': 'bold' }}>{po.location && po.location.name}</TableCell>
                <TableCell align="left" style={{fontWeight: isPOSeenBy(po, user) ? 'normal': 'bold' }}>{po.supplier && po.supplier.name}</TableCell>
                <TableCell align="right" style={{fontWeight: isPOSeenBy(po, user) ? 'normal': 'bold' }}>£{po.subtotal.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      { purchaseOrders && purchaseOrders.length > 0 && <div style={{marginTop: '20px'}}>
        <Typography>
          <Button onClick={this.previous} disabled={!before || loading} color='primary' variant='outlined'>Previous</Button>
          <span style={{margin: '0 16px'}}>Showing {start} - {end} of {count} results</span>
          <Button onClick={this.next} disabled={!after || loading} color='primary' variant='outlined'>Next</Button>
        </Typography>
      </div> }
    </>);
  }
}

export default PurchaseOrders